import { render, staticRenderFns } from "./chatSenders.vue?vue&type=template&id=602ef6cd&scoped=true"
import script from "./chatSenders.vue?vue&type=script&lang=js"
export * from "./chatSenders.vue?vue&type=script&lang=js"
import style0 from "./chatSenders.vue?vue&type=style&index=0&id=602ef6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ef6cd",
  null
  
)

export default component.exports